import { MenuItem } from '@mui/material';
import { FC } from 'react';
import { useQuery } from 'react-query';
import { SMBSelect } from '../input';
import { IDropdownResponse, IPlanOvenLayout } from '../../models';
import { getSalesLookupOvenLayouts } from '../../fetch/lookups/sales-portal';

interface ISalesOvenLayoutsDropdownProps {
  value: string | number;
  handleChange: (val: string | number) => void;
  isDisabled?: boolean;
  isRequired?: boolean;
  inputLabel?: string;
  handleClear?: () => void;
}

export const SalesOvenLayoutDropdown: FC<ISalesOvenLayoutsDropdownProps> = ({
  inputLabel,
  isDisabled,
  isRequired,
  value,
  handleChange,
  handleClear
}) => {
  const { isLoading: isLoadingOvenLayouts, data: ovenLayouts } = useQuery<
    IDropdownResponse[],
    Error
  >(['getPlanOvenLayouts'], () => getSalesLookupOvenLayouts(), {
    notifyOnChangeProps: 'tracked'
  });
  return (
    <SMBSelect
      label={isLoadingOvenLayouts ? 'Loading...' : inputLabel ?? 'Oven Layout'}
      disabled={isDisabled || isLoadingOvenLayouts}
      name="ovenLayouts"
      id="ovenLayouts"
      variant="outlined"
      value={value}
      required={isRequired}
      onChange={({ target: { value } }) => handleChange(value)}
      handleClear={() => {
        handleChange('');
        handleClear && handleClear();
      }}
      SelectProps={{
        MenuProps: {
          sx: {
            maxHeight: '30rem'
          }
        }
      }}
    >
      {!isLoadingOvenLayouts && !ovenLayouts && (
        <MenuItem disabled>No oven layouts available</MenuItem>
      )}
      {!isLoadingOvenLayouts &&
        ovenLayouts &&
        ovenLayouts.map((layout: IPlanOvenLayout, index) => {
          return (
            <MenuItem key={`${index}`} value={layout.value}>
              {layout.description}
            </MenuItem>
          );
        })}
    </SMBSelect>
  );
};
